<template>
    <v-card class="card-integration mt-2 mb-6" elevation='7' width='90%' raised max-width='360px' height='400px'>

        <v-card-text class="d-flex justify-center flex-column align-center">

            <v-btn class="mt-13 btn-plus" height='150' width='150' fab color='primary' @click.native="$emit('openDialog', 'dialogNewIntegration')">
                <v-icon size="35"> mdi-plus </v-icon>
            </v-btn>
 
            <div class="mt-3 font-weight-bold">{{$t('integrations.new_integration')}}</div>

        </v-card-text>

    </v-card>

</template>

<script>
export default {
    name: "SkeletonIntegrationCard"

}
</script>

<style>

</style>